angular.module("vgresiduos").component("measureUnit", {
	controller: "MeasureUnitCtrl",
	templateUrl: "views/components/fields/measureUnit/measureUnit_template.html",
	bindings: {
		onlyResidueUnits: "<?",
		onlySameGroup: "<?",
		isDisabled: "<?",
		isRequired: "<?",
		emptyField: "<?",
		measureUnitGroup: "<?",
		identifier: "<?",
		setterId: "<?",
		model: "=?",
		onChange: "<?"
	}
});
